import { ScheduleUtil } from './../utils/schedule.util';
import { HttpParams } from '@angular/common/http';
import { idsQueryParamsBuilder } from './ids-query-param-builder';

type QueryParamPrimitive = string | number | boolean;
type QueryParamValue = QueryParamPrimitive | Date | string[] | number[] | null | undefined;

export function buildQueryParams(params?: object): HttpParams {
  let httpParams = new HttpParams();

  if (!params) {
    return httpParams;
  }

  for (const [key, value] of Object.entries(params as Record<string, QueryParamValue>)) {
    if (value === undefined || value === null) {
      continue;
    }

    if (value instanceof Date) {
      httpParams = httpParams.append(key, ScheduleUtil.toHttpRequestFormat(value));
    } else if (Array.isArray(value)) {
      if (value.length > 0) {
        httpParams = httpParams.append(key, idsQueryParamsBuilder(value));
      }
    } else {
      httpParams = httpParams.append(key, String(value));
    }
  }

  return httpParams;
}
